import styled from 'styled-components';
import { LOGO } from '../../assets/media';

const Wrap = styled.footer`
  background: ${({ theme }) => theme.colors.bgDarker};
`;

const MapFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 300px;
  border: 0;
  filter: grayscale(1) invert(0.9) contrast(0.9);
`;

const Bottom = styled.div`
  max-width: 1160px;
  margin: 0 auto;
  padding: 1.75rem 1.25rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1.25rem;
  border-top: 3px solid ${({ theme }) => theme.colors.gold};
`;

const LogoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
`;

const LogoImg = styled.img`
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 2px solid #f4f3ee;
  object-fit: cover;
`;

const LogoText = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.62rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.24em;
  line-height: 1.5;
  color: #f4f3ee;
  margin: 0;

  span {
    display: block;
  }
`;

const Links = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-wrap: wrap;

  a {
    min-height: 44px;
    display: inline-flex;
    align-items: center;
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 0.68rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.18em;
    color: #cfccc3;
  }

  a:hover {
    color: ${({ theme }) => theme.colors.gold};
  }
`;

const Copy = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #8d897e;
`;

function Footer() {
  return (
    <Wrap id="contacto">
      <MapFrame
        title="Ubicación de Vete a la Chingada Despecho Bar"
        loading="lazy"
        src="https://www.google.com/maps?q=Ciudad+de+M%C3%A9xico&output=embed"
      />
      <Bottom>
        <LogoBox>
          <LogoImg src={LOGO} alt="" />
          <LogoText>
            <span>Vete a la</span>
            <span>Chingada</span>
          </LogoText>
        </LogoBox>
        <Links>
          <a
            href="https://instagram.com/vetealachingadaar_oficial"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>
          <a href="tel:+527770000000">777 000 0000</a>
          <a href="/admin">Admin</a>
        </Links>
        <Copy>© {new Date().getFullYear()} Vete a la Chingada Despecho Bar</Copy>
      </Bottom>
    </Wrap>
  );
}

export default Footer;
